import axios from 'axios';

import { PublicationNewAliasRequest } from '@/module/Author/Publication/model/PublicationTypes';
import { PublicationImpactFactor } from '@/module/Journal';

import { Id, PagedParams, PagedResponse, getData } from '@feature/utils';

import { Review, ReviewRequest } from './ReviewTypes';

export function getReviewImpactFactor(reviewId: Id) {
  return axios.get<PublicationImpactFactor>(`/author/reviews/${reviewId}/impact-metrics`, {}).then(getData);
}

export function getPaged(params: PagedParams) {
  return axios
    .get<PagedResponse<Review>>('/author/reviews/paged', {
      params,
    })
    .then(getData);
}

export function get(id: Id) {
  return axios.get<Review>(`/author/reviews/${id}`).then(getData);
}

export function edit(id: Id, request: ReviewRequest) {
  return axios.put<Review>(`/author/reviews/${id}`, request).then(getData);
}

export function create(request: ReviewRequest) {
  return axios.post<Review>(`/author/reviews`, request).then(getData);
}

export function deleteById(id: Id) {
  return axios.delete<unknown>(`/author/reviews/${id}`).then(getData);
}

export function addNewAlias(reviewId: Id, request: PublicationNewAliasRequest) {
  return axios.put(`/author/reviews/${reviewId}/add-new-alias`, request).then(getData);
}
